// import 'core-js/stable'
// import 'regenerator-runtime/runtime'
import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vuetify from '@/plugins/vuetify'
import filters from './filters'
import Chart from './components/Chart.vue'
import Confirm from './components/Confirm.vue'
import ScrollButtons from './components/ScrollButtons.vue'
import './styles/styles.scss'
import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";
import { Integrations } from "@sentry/tracing";
import VueGtm from '@gtm-support/vue2-gtm';

Sentry.init({
  dsn: "https://66287225a12843feb94b6a6e4047c27e@o483106.ingest.sentry.io/5538660",
  integrations: [
    new VueIntegration({
      Vue,
      tracing: true,
      logErrors: true
    }),
    new Integrations.BrowserTracing(),
  ],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});

Vue.config.productionTip = false

// Google Tag Manager
Vue.use(VueGtm, {
  id: 'GTM-PGM4539',
  defer: false,
  compatibility: false,
  enabled: true,
  debug: false,
  loadScript: true,
  vueRouter: router,
  trackOnNextTick: false
});

Vue.use(filters)
new Vue({
  render: h => h(App),
  vuetify,
  router,
  store,
  components: { App, Chart, Confirm, ScrollButtons }
}).$mount('#app')
